module.exports = __webpack_public_path__ + "img/82.39b4bf34.jpg";